import { createSlice } from "@reduxjs/toolkit";

export const applyPromoCodeSlice = createSlice({
  name: "applyPromoCode",
  initialState: {
    data: null,
    loading: false,
    error: { error: false, message: "" },
  },
  reducers: {
    setApplyPromoCodeData: (state, action) => {
      state.data = action.payload;
      state.error = { error: false, message: "" };
    },
    setApplyPromoCodeLoading: (state, action) => {
      state.loading = action.payload;
    },
    setApplyPromoCodeError: (state, action) => {
      state.error = action.payload;
      state.data = null;
    },
  },
});

export const {
  setApplyPromoCodeData,
  setApplyPromoCodeLoading,
  setApplyPromoCodeError,
} = applyPromoCodeSlice.actions;

export default applyPromoCodeSlice.reducer;
